import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { volverTrasGuardar } from "../../../utils/volverTrasGuardar";

const FormularioAlumno = ({ modo }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [originalId, setOriginalId] = useState("");

  const [form, setForm] = useState({
    id_alumno: "",
    nombre: "",
    id_piso: "",
    habitacion: "",
    duracion: "",
    pais: "",
    a_r: "",
  });

  const [pisos, setPisos] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`/api/pisos/`)
      .then(res => setPisos(Array.isArray(res.data) ? res.data : []))
      .catch(() => setPisos([]));
  }, []);

  useEffect(() => {
    if (modo === "editar" && id) {
      axios.get(`/api/alumnos/${id}`)
        .then(res => {
          if (res.data) {
            const d = res.data;
            setForm({
              id_alumno: d.id_alumno || "",
              nombre: d.nombre || "",
              id_piso: d.id_piso ?? "",
              habitacion: d.habitacion || "",
              duracion: d.duracion || "",
              pais: d.pais || "",
              a_r: d.a_r || "",
            });
            setOriginalId(d.id_alumno);
          } else {
            alert("❌ Alumno no encontrado");
            navigate("/admin/alumnos");
          }
        })
        .catch(() => alert("❌ Error al cargar el alumno"));
    }
  }, [modo, id, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!form.id_alumno || !form.nombre || !form.id_piso) {
      alert("❗ ID alumno, nombre y piso son obligatorios.");
      return;
    }
    if (!window.confirm("¿Confirmar operación?")) return;

    const url = modo === "editar" ? `/api/alumnos/${originalId}` : `/api/alumnos/`;
    const method = modo === "editar" ? "put" : "post";
    try {
      const payload = Object.fromEntries(
        Object.entries(form).map(([k, v]) => [k, v === "" ? null : v])
      );
      await axios[method](url, payload);
      alert(modo === "editar" ? "✅ Alumno actualizado" : "✅ Alumno creado");
      volverTrasGuardar(navigate, "/admin/alumnos");
    } catch (err) {
      const msg = err.response?.data?.error || "❌ Error inesperado.";
      setError(msg);
      alert(msg);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2 style={styles.title}>{modo === "editar" ? "✏️ Editar Alumno" : "🆕 Nuevo Alumno"}</h2>
        {error && <p style={styles.error}>{error}</p>}
        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.fila2}>
            <div style={styles.campo}>
              <label style={styles.label}>ID alumno</label>
              <input
                type="number"
                name="id_alumno"
                placeholder="Ej: 1234"
                value={form.id_alumno}
                onChange={handleChange}
                required
                disabled={modo === "editar"}
                style={{ ...styles.input, ...(modo === "editar" ? styles.inputDisabled : {}) }}
              />
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Nombre</label>
              <input
                name="nombre"
                placeholder='Ej. "Daniela A."'
                value={form.nombre}
                onChange={handleChange}
                required
                style={styles.input}
              />
            </div>
          </div>

          <div style={styles.campo}>
            <label style={styles.label}>Piso</label>
            <select name="id_piso" value={form.id_piso} onChange={handleChange} required style={styles.select}>
              <option value="">-- Piso --</option>
              {pisos.map(p => (
                <option key={p.id} value={p.id}>{p.abreviatura} ({p.id})</option>
              ))}
            </select>
          </div>

          <div style={styles.fila2}>
            <div style={styles.campo}>
              <label style={styles.label}>Habitación</label>
              <input name="habitacion" placeholder="Ej. 3B" value={form.habitacion} onChange={handleChange} style={styles.input} />
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>Duración</label>
              <select name="duracion" value={form.duracion} onChange={handleChange} style={styles.select}>
                <option value="">-- Duración --</option>
                <option value="C">C</option>
                <option value="1">1</option>
                <option value="2">2</option>
              </select>
            </div>
          </div>

          <div style={styles.fila2}>
            <div style={styles.campo}>
              <label style={styles.label}>País</label>
              <input name="pais" placeholder="Ej. ESP, MEX..." value={form.pais} onChange={handleChange} maxLength={10} style={styles.input} />
            </div>
            <div style={styles.campo}>
              <label style={styles.label}>A/R</label>
              <input name="a_r" placeholder="Ej. A, R1, R2..." value={form.a_r} onChange={handleChange} maxLength={5} style={styles.input} />
            </div>
          </div>

          <div style={styles.botones}>
            <button type="button" onClick={() => navigate(-1)} style={styles.btnCancelar}>
              Cancelar
            </button>
            <button type="submit" style={styles.btnGuardar}>
              {modo === "editar" ? "💾 Guardar cambios" : "➕ Crear Alumno"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const styles = {
  page: { padding: "32px 16px", background: "#f4f6f8", minHeight: "100vh" },
  card: {
    maxWidth: 620, margin: "0 auto", background: "#fff", borderRadius: 16,
    boxShadow: "0 8px 28px rgba(0,0,0,0.08)", padding: "32px 36px",
  },
  title: { margin: "0 0 22px", fontSize: 22, color: "#263238" },
  error: {
    background: "#fdecea", color: "#c0392b", border: "1px solid #f3c2bd",
    borderRadius: 8, padding: "10px 14px", marginBottom: 16, fontSize: 14,
  },
  form: { display: "flex", flexDirection: "column", gap: 18 },
  fila2: { display: "flex", gap: 16, flexWrap: "wrap" },
  campo: { display: "flex", flexDirection: "column", gap: 6, flex: 1, minWidth: 180 },
  label: { fontSize: 12, fontWeight: 700, color: "#607d8b", textTransform: "uppercase", letterSpacing: 0.4 },
  input: { padding: "11px 14px", fontSize: 15, border: "1px solid #cfd8dc", borderRadius: 10, outline: "none" },
  inputDisabled: { background: "#f5f5f5", color: "#90a4ae" },
  select: { padding: "11px 14px", fontSize: 15, border: "1px solid #cfd8dc", borderRadius: 10, cursor: "pointer", background: "#fff" },
  botones: { display: "flex", gap: 12, marginTop: 8 },
  btnCancelar: {
    flex: 1, background: "#fff", color: "#c0392b", border: "1px solid #e57373",
    padding: "12px", borderRadius: 10, fontWeight: 700, cursor: "pointer", fontSize: 15,
  },
  btnGuardar: {
    flex: 1, background: "linear-gradient(135deg,#43a047,#2e7d32)", color: "#fff", border: "none",
    padding: "12px", borderRadius: 10, fontWeight: 700, cursor: "pointer", fontSize: 15,
    boxShadow: "0 4px 10px rgba(46,125,50,0.35)",
  },
};

export default FormularioAlumno;
